import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BulletinService {
  private bulletin: string = '';
  changeBulletin = new BehaviorSubject<string>('');
  constructor(private http: HttpClient) {}

  fetchBulletin() {
    this.http
      .get<string>(environment.firebaseConfig.databaseURL + '/bulletin.json')
      .subscribe(
        (res) => {
          this.setBulletin(res);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  setBulletin(bulletin: string) {
    this.bulletin = bulletin[0];
    this.changeBulletin.next(this.bulletin);
  }
}
